import React from 'react';
import { Link } from 'react-router-dom';
import './rowLink.css';

export const isNewTabClick = (e) => e.metaKey || e.ctrlKey || e.shiftKey;

const openInNewTab = (url) => window.open(url, '_blank', 'noopener');

// Table onRow props: plain click -> onNavigate, cmd/ctrl/shift or middle click -> new tab.
// Clicks on a row link are left to the browser so its native behavior applies.
export const getRowLinkProps = (url, onNavigate, { shouldIgnore } = {}) => ({
  onClick: (e) => {
    if (shouldIgnore?.(e)) return;
    if (isNewTabClick(e)) {
      if (!e.target.closest('a')) openInNewTab(url);
      return;
    }
    onNavigate(e);
  },
  onAuxClick: (e) => {
    if (e.button !== 1 || shouldIgnore?.(e) || e.target.closest('a')) return;
    openInNewTab(url);
  },
  style: { cursor: 'pointer' },
});

// Makes every cell a real anchor stretched over the cell, so the whole row
// behaves like a link (right-click "Open in new tab", cmd/middle click).
// Plain clicks are still handled by the row's onClick.
// `exclude` lists column keys with their own interactive content (switches, previews, drag handles).
export const withRowLink = (columns, getUrl, { exclude = [], disabled = false } = {}) => {
  if (disabled) return columns;
  return columns.map((column) => {
    if (exclude.includes(column.key)) return column;
    const { render, onCell } = column;
    return {
      ...column,
      onCell: (record, index) => {
        const cellProps = onCell?.(record, index) || {};
        return {
          ...cellProps,
          className: [cellProps.className, 'row-link-cell'].filter(Boolean).join(' '),
        };
      },
      render: (value, record, index) => (
        <Link
          to={getUrl(record)}
          className="row-link"
          draggable={false}
          onClick={(e) => {
            if (!isNewTabClick(e)) e.preventDefault();
          }}
        >
          <div className="row-link-content">
            {render ? render(value, record, index) : value}
          </div>
        </Link>
      ),
    };
  });
};
